import { isDateAfter, isDateEarlier, isDatePast, isTimePast } from '../../../utils/dateFunctions';
import {
    getCharMinMessage,
    getDateMaxMessage,
    getNowDateOrEarlierMessage,
    getNowDateOrLaterMessage,
    getSameDateOrLater
} from '../../../utils/formValidation/errorMessageFunctions';

export const MIN_ACTION_TITLE = 5;
export const MIN_ACTION = 50;
export const MAX_ACTION_DESCRIPTION = 750;
export const MAX_ACTION_COMMENTS = 500;
export const MAX_ACTION_TITLE = 100;

export const validateActionTitle = (actionTitle, errors) => {
    if (actionTitle.trim().length < MIN_ACTION_TITLE) {
        return {
            ...errors,
            actionTitle: {
                error: true,
                message: getCharMinMessage('Action title', MIN_ACTION_TITLE)
            }
        };
    }
    return errors;
};

export const validateAction = (action, errors) => {
    if (action.trim().length < MIN_ACTION) {
        return {
            ...errors,
            action: {
                error: true,
                message: getCharMinMessage('Action description', MIN_ACTION)
            }
        };
    }
    return errors;
};

export const validateActionDueDate = (actionDueDate, contractEndDate, errors) => {
    if (actionDueDate) {
        if (isDatePast(actionDueDate)) {
            return {
                ...errors,
                actionDueDate: { error: true, message: getNowDateOrLaterMessage() }
            };
        } else if (isDateAfter(actionDueDate, contractEndDate)) {
            return {
                ...errors,
                actionDueDate: {
                    error: true,
                    message: getDateMaxMessage('contract end date')
                }
            };
        }
    }
    return errors;
};

export const validateActionOutcomeDate = (actionOutcomeDate, actionStartDate, errors) => {
    if (actionOutcomeDate) {
        if (!isTimePast(actionOutcomeDate)) {
            return {
                ...errors,
                actionOutcomeDate: {
                    error: true,
                    message: getNowDateOrEarlierMessage()
                }
            };
        } else if (isDateEarlier(actionStartDate, actionOutcomeDate)) {
            return {
                ...errors,
                actionOutcomeDate: {
                    error: true,
                    message: getSameDateOrLater('start date')
                }
            };
        }
    }
    return errors;
};
